// import { useMutation } from '@apollo/client';
// import {
//   ChangeOtherItemStatus,
//   ChangeOtherItemStatusVariables,
// } from '../graphql-types/ChangeOtherItemStatus';
// import { CHANGE_OTHER_ITEM_STATUS, GET_OTHER_ITEMS } from '../graphql';

// export const useChangeOtherItemStatus = () => {
//   const [mutate, state] = useMutation<
//     ChangeOtherItemStatus,
//     ChangeOtherItemStatusVariables
//   >(CHANGE_OTHER_ITEM_STATUS, {
//     refetchQueries: [GET_OTHER_ITEMS],
//   });

//   const changeStatus = async (
//     input: ChangeOtherItemStatusVariables['input'],
//   ) => {
//     const { data } = await mutate({
//       variables: { input },
//     });

//     return data?.changeOtherItemStatus;
//   };

//   return {
//     changeStatus,
//     ...state,
//   };
// };
import { useMutation } from '@apollo/client';
import {
  ChangeOtherItemStatus,
  ChangeOtherItemStatusVariables,
} from '../graphql-types/ChangeOtherItemStatus';
import { CHANGE_OTHER_ITEM_STATUS } from '../graphql';

export const useChangeOtherItemStatus = () => {
  const [mutate, state] = useMutation<
    ChangeOtherItemStatus,
    ChangeOtherItemStatusVariables
  >(CHANGE_OTHER_ITEM_STATUS); // ✅ remove refetchQueries

  const changeStatus = (
    input: ChangeOtherItemStatusVariables['input'],
    options?: Parameters<typeof mutate>[0], // ✅ allow passing cache options
  ) => {
    return mutate({
      variables: { input },
      ...options,
    });
  };

  return {
    changeStatus,
    ...state,
  };
};
